import { Model } from '../../domain.js';
import { InvalidSortError } from '../Errors/InvalidSortError.js';
export class SortValueObject extends Model {
  static validate(_ref) {
    let {
      criteria
    } = _ref;

    if (!criteria || !Array.isArray(criteria)) {
      throw InvalidSortError.create("[SortValueObject.validate] required an array of criteria(" + criteria + ")");
    }
  }

  static create(_ref2) {
    let {
      criteria,
      fields = []
    } = _ref2;
    SortValueObject.validate({
      criteria
    });
    return new SortValueObject({
      criteria,
      fields
    });
  }

  constructor(_ref3) {
    let {
      criteria,
      fields
    } = _ref3;
    super();
    this._value = [];
    this._criteria = [];
    this._criteria = criteria;
    this._value = fields;
  }

  addCriterias(fields) {
    if (!Array.isArray(fields)) {
      throw InvalidSortError.create("[SortValueObject#addCriterias] must be an Array fields(" + fields + ")");
    }

    fields.forEach(field => this.addCriteria(field));
    return this;
  }

  addCriteria(_ref4) {
    let {
      field,
      order = SortValueObject.ORDER.ASC
    } = _ref4;

    if (!this._criteria.includes(field)) {
      throw InvalidSortError.create("[SortValueObject#addCriteria] forbidden field(" + field + ")");
    }

    if (order !== SortValueObject.ORDER.ASC && order !== SortValueObject.ORDER.DESC) {
      throw InvalidSortError.create("[SortValueObject#addCriteria] forbidden order(" + order + ")");
    }

    this._value.push(order === SortValueObject.ORDER.DESC ? "-" + field : field);

    return this;
  }

  toJSON() {
    return {
      criteria: this._criteria,
      fields: this._value
    };
  }

  toParams() {
    if (this._value.length === 0) {
      return {};
    }

    return {
      sort: this._value.join()
    };
  }

  toString() {
    if (this._value.length === 0) {
      return '';
    }

    return "sort=" + this._value.join();
  }

}
SortValueObject.ORDER = {
  ASC: 'asc',
  DESC: 'desc'
};